import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { Avatar, Box, Divider, Typography } from '@mui/material';
import { getMediaLogo } from '../../utils/file.ts';
import telegramChatInputImg from '../../assets/telegram-chat-input.svg';
import { CampaignContext } from '../../contexts/CampaignContext.tsx';
import { Media, Social } from '../../interfaces/campaign.ts';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import handleFormatFile from '../../utils/handleFormatFile.tsx';
import { Image } from '@mui/icons-material';

interface IData {
	title: string;
	release_hour: string;
	release_date: string;
	advertiser: string;
	ad_receiver: string;
	media: Media;
	content: {
		image: null | string;
		description: string;
		caption: string;
		handle_name: string;
		tags: string[];
	};
	handle_name: string;
}

const AdDetails = () => {
	const { t } = useTranslation();

	const { id } = useParams();

	const [data, setData] = useState<IData>();

	const { fetchedCampaign } = useContext(CampaignContext);
	const platform = fetchedCampaign?.media! as Social;

	useEffect(() => {
		axios({
			method: 'GET',
			url: `/duties/${id}`,
		}).then(r => {
			if (r?.data?.success) {
				setData(r?.data?.data);
			}
		});
	}, []);

	return (
		<>
			<div className="flex w-full flex-col items-start gap-6 rounded-lg bg-white p-6 shadow-md lg:flex-row">
				<div className="min-w-80 rounded-2xl border border-primary-outborder pb-1 lg:w-1/3">
					<Box className="flex items-center justify-between border border-x-0 border-t-0 border-b-primary-outborder px-4 py-2">
						<Divider orientation="horizontal" className="mx-2 w-3/4 bg-grey-100" />
						<img src={data?.media ? getMediaLogo(data?.media as Media) : ''} alt={`${platform} logo`} className="h-7 w-7" />
					</Box>
					<Box className="flex flex-col justify-between">
						<Box className="mx-2 mt-2">
							{handleFormatFile(data?.content?.image) === 'video' ? (
								<video src={data?.content?.image ?? ''} controls className="mb-2 h-64 w-full rounded-2xl" />
							) : (
								<Avatar src={data?.content?.image ?? ''} alt={data?.title} className="mb-2 h-64 w-full rounded-2xl">
									<Image />
								</Avatar>
							)}
							<Typography className="line-clamp-1 h-4 text-xs font-normal text-text-primary">{data?.content?.caption ?? ' '}</Typography>
							<Typography className="mb-1 text-xs font-normal text-blue-400">@{data?.handle_name}</Typography>
							<Box className="flex gap-1">
								{data?.content?.tags?.map((tag, i) => (
									<Typography key={i} className="text-xs font-normal text-secondary-main">
										#{tag}
									</Typography>
								))}
							</Box>
						</Box>
						<img src={telegramChatInputImg} alt={`chat input img`} className="w-full" />
					</Box>
				</div>

				<div className="flex flex-col gap-4 lg:w-2/3">
					<div className="flex flex-col gap-2 py-4">
						<Typography className="text-sm text-text-primary">{t('instructions')}</Typography>
						<Typography className="text-justify text-base leading-6 text-text-secondary">{data?.content?.description}</Typography>
					</div>
					<Divider />
					<div className="flex gap-10 py-4">
						<Typography className="text-sm text-text-primary">{t('ad_giver')}</Typography>
						<Typography className="text-base text-text-secondary">{data?.advertiser}</Typography>
					</div>
					<Divider />
					<div className="flex gap-10 py-4">
						<Typography className="text-sm text-text-primary">{t('ad_reciever')}</Typography>
						<Typography className="text-base text-text-secondary">{data?.ad_receiver}</Typography>
					</div>
					<Divider />
					<div className="flex gap-10 py-4">
						<Typography className="text-sm text-text-primary">{t('publish_ad_hour')}</Typography>
						<Typography className="text-base text-text-secondary">{data?.release_hour}</Typography>
					</div>
					<Divider />
					<div className="flex gap-10 py-4">
						<Typography className="text-sm text-text-primary">{t('week_date_and_day')}</Typography>
						<Typography className="text-base text-text-secondary">
							{new Date(data?.release_date ?? '')?.toLocaleString('fa-IR', { weekday: 'long', calendar: 'persian' })} {new Date(data?.release_date ?? '')?.toLocaleString('fa-IR').split(',')[0]}
						</Typography>
					</div>
				</div>
			</div>
		</>
	);
};
export default AdDetails;
